export interface DailyBonusMockCard {
  amount: number;
  activations: number;
  state: 'ready' | 'claimed' | 'locked';
}

export const DAILY_BONUS_MOCK_CARDS: DailyBonusMockCard[] = [
  { amount: 0.5, activations: 7, state: 'locked' },
  { amount: 1, activations: 6, state: 'locked' },
  { amount: 2, activations: 6, state: 'locked' },
  { amount: 3, activations: 6, state: 'locked' },
  { amount: 4.5, activations: 6, state: 'locked' },
  { amount: 7, activations: 6, state: 'locked' },
  { amount: 8, activations: 6, state: 'locked' },
  { amount: 15, activations: 6, state: 'locked' },
  { amount: 10, activations: 6, state: 'locked' },
  { amount: 25, activations: 6, state: 'locked' },
];
